// The consumer account's ledger, as GET /v1/account returns it. See Design >
// Exchange, "Consumer accounts" and "Money". Amounts are US dollars; a charge is
// negative, and a refund and the starting grant are positive.

import type { LedgerRow } from "./types.ts";

export type LedgerLine = {
  type: "Grant" | "Charge" | "Refund" | string;
  what: string;
  amount: number;
  at: number;
  answerId: string | null;
};

const shortId = (id: string) => id.slice(0, 8);

type KindText = { type: string; what: string };

const KINDS = new Map<string, (row: LedgerRow) => KindText>([
  ["grant", () => ({ type: "Grant", what: "Starting credits" })],
  ["charge", (row) => ({ type: "Charge", what: row.answerId ? `Answer ${shortId(row.answerId)}` : "Answer" })],
  ["refund", (row) => ({ type: "Refund", what: row.answerId ? `Refund for answer ${shortId(row.answerId)}` : "Refund" })],
]);

export function ledgerLine(row: LedgerRow): LedgerLine {
  const base = { amount: row.amount, at: row.createdAt, answerId: row.answerId };
  // A kind that the Console doesn't know is shown as the Exchange named it.
  const named = KINDS.get(row.kind)?.(row) ?? { type: row.kind, what: row.kind };
  return { ...base, ...named };
}
